import { prodApiLSKey } from '@/components/QATools/ls-keys';
import { dedupedTryRefresh, getSessionManager } from '@/utils/session';
import { BASE_URL, PRODUCTION } from '@env';
import type { BaseQueryFn, FetchBaseQueryError } from '@reduxjs/toolkit/query';
import { createApi, fetchBaseQuery } from '@reduxjs/toolkit/query/react';

const DEV_BASE_URL =
  window.localStorage.getItem(prodApiLSKey) === 'true' ? 'https://prod-api.marpla.ru/' : BASE_URL;

export function createBaseQueryWith401Retry(
  baseUrl: string,
): BaseQueryFn<any, unknown, FetchBaseQueryError> {
  const rawBaseQuery = fetchBaseQuery({
    baseUrl,
    prepareHeaders: async (headers) => {
      await dedupedTryRefresh();

      const token = getSessionManager().getAccessToken();

      if (token) {
        headers.set('Authorization', `Bearer ${token}`);
      }

      return headers;
    },
  });

  return async (args, api, extraOptions) => {
    let result = await rawBaseQuery(args, api, extraOptions);

    if (
      result.error &&
      result.error.status === 401 &&
      !(extraOptions as { __retried401?: boolean } | undefined)?.__retried401
    ) {
      await dedupedTryRefresh(true);

      const retriedOptions = { ...extraOptions, __retried401: true };
      result = await rawBaseQuery(args, api, retriedOptions);
    }

    return result;
  };
}

export const rtkQueryApi = createApi({
  baseQuery: createBaseQueryWith401Retry(PRODUCTION ? BASE_URL : DEV_BASE_URL),
  endpoints: () => ({}),
});
